// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseOptions } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, Auth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyCcxGkoKGRvRsqHAPoesQm60ZTJWQGsRbg",
  authDomain: "artworkbyjocelyn.firebaseapp.com",
  projectId: "artworkbyjocelyn",
  storageBucket: "artworkbyjocelyn.appspot.com",
  messagingSenderId: "503409697006",
  appId: "1:503409697006:web:b3c6ab17afbbccd1ead3ff",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const auth: Auth = getAuth(app);
export { auth };
export default getFirestore();
export const db = getFirestore(app);
